var assign = require('@antv/util/lib/mix');

module.exports = {
  assign: assign
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/hierarchy/lib/util.js
// module id = 28
// module chunks = 0